import { QuizContext } from '@context/QuizContext'
import { Flex, Text } from '@mantine/core'
import React, { useContext } from 'react'

const Explaination = () => {
    const { currentStep } = useContext(QuizContext)

    if (currentStep === 6) {
        return <></>
    }
    return (
        <Flex gap='4px'>
            <Text fw='bold' c='blue.5'>
                คำชี้แจง
            </Text>
            <Text>โปรดกรอกข้อมูลของท่านลงในช่องว่าง</Text>
        </Flex>
    )
}

export default Explaination
